import React from "react";
import HeroSlider from "../components/accueil/HeroSlider";
import Welcome from "../components/accueil/welcome";
import Sommenous from "../components/Sommenous";
import Activite from "../components/accueil/Activite";
import AvisClients from "../components/accueil/Avisclients";
import NosServices from "../components/NosServices";
import ProjetsRecents from "../components/ProjetsRecents";
import LocationMap from "../components/LocationMap";

const Accueil: React.FC = () => {
  return (
    <div>
      <HeroSlider />
      <Activite />
      <Sommenous />
      <NosServices />
      <ProjetsRecents />
      <LocationMap />
    </div>
  );
};

export default Accueil;